import Vue from 'vue';
import BaseService from '@/services/BaseService';
import Store from '@/store';
import UserModel from '@/models/UserModel';

class UserService extends BaseService {
  static changePassword(id, password) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/${id}/password/`, {
          password,
        })
        .then(response => resolve(response))
        .catch(err => reject(err));
    });
  }
  static login(userData) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/login/`, userData)
        .then((response) => {
          Store.commit('login', response.body);
          return resolve(response.body);
        })
        .catch(err => reject(err));
    });
  }

  static logout() {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/logout/`)
        .then((response) => {
          Store.commit('logout');
          return resolve(response.body);
        })
        .catch(err => reject(err));
    });
  }
}

Object.assign(UserService, {
  resource: 'users',
  model: UserModel,
});

export default UserService;
